export default "__VITE_ASSET__FIg0WafF__"